export function makeOpenApiUrls(opernApiServer) {
    const openApiUrl = opernApiServer + '/backoffice/proxy/open-api';
    return {
        // #region 菜单分类
        getCategories: openApiUrl + '/category/get',
        saveCategory: openApiUrl + '/category/save',
        removeCategory: openApiUrl + '/category/delete-category',
        removeSubCategory: openApiUrl + '/category/delete-child-category',
        // #endregion
        // #region 白名单
        getWhitelist: openApiUrl + '/whitelist/get',
        saveWhitelist: openApiUrl + '/whitelist/save',
        getWhitelistApi: openApiUrl + '/whitelist/api-get',
        removeWhitelistItem: openApiUrl + '/whitelist/delete',
        // #endregion
        // #region api maintain
        uploadSwagger: openApiUrl + '/api-maintain/file-analysis',
        saveApi: openApiUrl + '/api-maintain/save',
        getApiList: openApiUrl + '/api-maintain/list',
        removeApi: openApiUrl + '/api-maintain/delete',
        setApiTagApi: openApiUrl + '/api-maintain/tag-maintenance',
        publish: openApiUrl + '/api-maintain/release',
        createPdf: openApiUrl + '/api-maintain/generatePdf',
        uploadPdf: openApiUrl + '/api-maintain/upload',
        updatePdfKey: openApiUrl + '/api-maintain/updatePdfKey',
        uploadPdfSubmit: openApiUrl + '/api-maintain/updatePdfKey',
        documentGroupList: openApiUrl + '/api-maintain/list/search',
        addVersionSubmit: openApiUrl + '/api-maintain/update/version/group',
        // #api file maintain
        getPdfRecord: openApiUrl + '/api-maintain/getPdfGenerateRecordPage',
        generatePdfBatch: openApiUrl + '/api-maintain/generatePdfBatch',
        getAllApiList: openApiUrl + '/api-maintain/getGroupApiInfo',
        downloadPdf: openApiUrl + '/api-maintain/getDownloadPdfUrl',
        deletePdfRecord: openApiUrl + '/api-maintain/deleteGeneratePdfRecordById',
        // #endregion
        // #region package
        getProducts: openApiUrl + '/product/get',
        getPackages: openApiUrl + '/package/get',
        savePackage: openApiUrl + '/package/update',
        // #endregion
        // #region api analysis
        getCompanyPackages: openApiUrl + '/analysis/package',
        getMonthlyBill: openApiUrl + '/analysis/monthly-bills',
        getPackageUsage: openApiUrl + '/analysis/package-usage',
        downloadExcelExport: openApiUrl + '/analysis/excel-export',
        getCustomerRanking: openApiUrl + '/analysis/customer-ranking',
        getCompanyList: openApiUrl + '/analysis/company',
        getPackageRanking: openApiUrl + '/analysis/package-ranking',
        getAPIRanking: openApiUrl + '/analysis/api-ranking',
        // #endregion
        // #region Package Quota Distribution（套餐额度分配）
        findPackageLimit: openApiUrl + '/package-limit/find',
        savePackageLimit: openApiUrl + '/package-limit/save',
        // #endregion
        // #region ContentConfigurable(门户网站数据配置)
        getConfigList: openApiUrl + '/config/query',
        saveConfig: openApiUrl + '/config/save',
        configUpload: openApiUrl + '/config/upload',
        deleteConfig: openApiUrl + '/config',
        addSolutionGroup: openApiUrl + '/config/customer/category/save',
        deleteSolutionGroup: openApiUrl + '/config/customer/category/delete',
        getSolutionGroup: openApiUrl + '/config/customer/category/list',
        // #endregion
        // #region Solution(租户key)
        getTenantKey: openApiUrl + '/tenant-mapping',
        getRechargeRecord: openApiUrl + '/tenant-mapping/balances',
        getTenantDeveloper: openApiUrl + '/tenant-mapping/developers',
    };
}
